import React, { useState } from "react";
import { AlertModal } from "../c/Modals";
import { T } from "../traks";
import { LL } from "./LL";

const LinkCopy = ({ link, pathId = undefined, handleDeleteLink = undefined, dataCy = undefined, handleDeactivateLink = undefined }) => {
	const [showAlert, setShowAlert] = useState(false)
	link = LL(`/${link}`)
	if (pathId) {
        link += '/' + pathId;
    }
	const copyText = () => {
		navigator.clipboard.writeText(link);
		setShowAlert(true)
	};

	return (
		<>
			<div className="border_radius_6px bg_light_grey pt-2 sibilus_border shadow" data-cy={dataCy}>
				<div className="px-3 py-3 border_radius_6px bg-white mx-2 cursor_pointer hover">
					<a href={link} target="_blank" rel="noreferrer" className="no-style">
						<div className="d-flex flex-row align-items-center justify-content-between">
							<div className="d-flex whistle_link_box">
								<img src="https://static.sibilus.eu/gfx/link-icon-0.svg" alt="link-icon" className="me-4" style={{ marginTop: '-6px' }} />
								<div className="primary fw_600 font_monospace">{window.location.origin + link}</div>
							</div>
							<div className="d-none d-lg-flex">
								<img src="https://static.sibilus.eu/gfx/active-icon-1.svg" alt="active-icon" />
							</div>
						</div>
					</a>
				</div>
				<div className="mt-1 ps-3 py-3">
					<span className="btn" onClick={() => copyText()}>
						<img src="https://static.sibilus.eu/gfx/copy-icon-0.svg" alt="copy-icon" className="mx-2" style={{ marginTop: '-6px' }} />
						<T>Copy Link</T>
					</span>
					{handleDeleteLink && (
						<span data-cy="deleteLink" className="btn" onClick={() => handleDeleteLink(pathId)}>
							<img src="https://static.sibilus.eu/gfx/delete-icon-0.svg" alt="delete-icon" className="mx-2" style={{ marginTop: '-6px' }} />
							<T>Delete Link</T>
						</span>
					)}
					{handleDeactivateLink && (
						<span className="btn" onClick={() => handleDeactivateLink(pathId)}>
							<img src="https://static.sibilus.eu/gfx/deactivate-icon-0.svg" alt="deactivate-icon" className="mx-2" style={{ marginTop: '-6px' }} />
							<T>Deactivate Link</T>
						</span>
					)}
				</div>
			</div>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={"success"}
				text={"Link copied to your clipboard"}
			/>
		</>
	);
};

export default LinkCopy
